import React, { useEffect, useState } from 'react';
import { AnalyticIcon, PlusIcon, SettingsIcon } from '../../assets/icons/icons';
import { BiExport } from "react-icons/bi";
import IconButton from '../../components/shared/IconButton';
import EventCardOrganizer from '../../components/modules/events/EventCardOrganizer';
import { apiConnecter } from '../../services/apiConnector';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { DownloadIcon } from 'lucide-react';
import API_ENDPOINTS from '../../constant//EndPoints';
import { HiOutlineRefresh } from "react-icons/hi";
import { exportEventAsCSV } from '../../services/exportEventAsCSV';
import { VscFeedback } from 'react-icons/vsc';

const OrganizerDashboard = () => {
    /* ****************************************************************
   *                            STATES                             *
   ******************************************************************/
    const [eventsData, setEventData] = useState([]);
    const userInfo = useSelector((state) => state.userInfo)
    const [showForm, setShowForm] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const [fieldErrors, setFieldErrors] = useState({});
    const [allEvents, setAllEvents] = useState([]);
    const [eventToUpdate, setEventToUpdate] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredEvents, setFilteredEvents] = useState([]);
    const navigate = useNavigate();

    /* ****************************************************************
      *                            HELPER FUNCTION                      *
      ******************************************************************/
    /**
     * Fetches the event data for the organizer based on their user ID.
     * @returns {void}
     */
    const getAllEventsDataHandler = async () => {
        setLoading(true);
        try {
            console.log(userInfo);

            const response = await apiConnecter("GET", `${API_ENDPOINTS.REACT_APP_GET_ORGANIZER_EVENTS_BY_ID_END_POINT}/${userInfo.user.id}`,
                null, { authorization: `Bearer ${userInfo.token}` });
            console.log("get all events api response", response);
            // setSuccess(response.data.message);
            setEventData(response.data.result);
            setFilteredEvents(response.data.result);
        } catch (err) {
            setError({ title: "Error", message: err?.response?.data?.message ?? err.message });
        } finally {
            setLoading(false);
        }
    };
    /**
     * Exports all event data as a CSV file.
     * Calls the `exportEventAsCSV` function to convert the event data to CSV format and trigger download.
     * 
     * @returns {void}
     */
    function handleExportall() {
        exportEventAsCSV(eventsData)
    }

    /* ****************************************************************
       *                             EFFECT HOOKS                        *
       ******************************************************************/

    useEffect(() => {
        getAllEventsDataHandler()
    }, [])

    return (
        <div className='flex flex-col w-full m-5'>
            <div className="flex items-center justify-between mb-6 flex-wrap gap-2">
                {/* Header */}
                <div>
                    <h2 className="text-2xl font-semibold text-[var(--primary-text-color)]">Your Events</h2>
                    <p className="text-gray-400 text-sm mt-1">View analytics and manage your assigned SparkMotion events</p>
                </div>

                {/* Export and refresh Buttons */}
                <div className='flex gap-2' >
                    <div disabled={loading}>
                        <IconButton
                            icon={BiExport}
                            label="Export All"
                            onClick={handleExportall}
                            hoverColor="hover:bg-gray-600"
                            bgColor="bg-[var(--color-surface-background)]"
                            border={true}
                            disabled={loading}
                        />
                    </div>
                    <IconButton
                        icon={HiOutlineRefresh}
                        label="Refresh"
                        onClick={getAllEventsDataHandler}
                        hoverColor="hover:bg-gray-600"
                        bgColor="bg-[var(--color-surface-background)]"
                        border={true}
                    // disabled={loading}
                    />

                </div>

            </div>

            {/* Scrollable container for event cards */}
            <div className="space-y-6 overflow-y-auto  custom-scrollbar">
                {
                    loading ? (
                        <div className="text-center py-4  bg-[var(--color-surface-background)]">
                            <div className="loader"></div>
                        </div>
                    ) : (
                        eventsData?.map((event, index) => (
                            <EventCardOrganizer key={index} event={event} userInfo={userInfo} getAllEventsDataHandler={getAllEventsDataHandler} />
                        ))
                    )
                }
                {
                    !loading && eventsData?.length == 0 && <>
                        <div className="text-center text-[var(--color-text-secondary)]   py-4 bg-[var(--color-surface-background)]">
                            <p className="">No events assigned.</p>
                        </div>
                    </>
                }


            </div>
        </div>
    );
};

export default OrganizerDashboard;

